var core = module.exports = { version: '2.5.6' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef



//////////////////
// WEBPACK FOOTER
// ../js/~/core-js/library/modules/_core.js
// module id = 16
// module chunks = 0